import { useEffect, useRef, useState } from 'react';
import { Loader, Stack, Text } from '@mantine/core';
import useApi from '../../hooks/useApi';
import { discoverV2Campaign } from '../../services/api';

const NARRATION = [
  'Reading what you told me…',
  'Thinking about your campaign…',
  'Shaping the plan…',
];

export default function DiscoveringScreen({
  flow,
  answers,
  onProposal,
  onError,
  campaignId = null,
}) {
  const api = useApi();
  const [lineIndex, setLineIndex] = useState(0);
  const startedRef = useRef(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setLineIndex((i) => (i + 1) % NARRATION.length);
    }, 2500);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;

    discoverV2Campaign(api, { flowId: flow.id, answers, campaignId })
      .then((response) => onProposal(response))
      .catch((err) => onError(err.response?.data?.error || err.message || 'Something went wrong'));
  }, [api, flow, answers, onProposal, onError, campaignId]);

  return (
    <Stack align="center" justify="center" gap="lg" py={80}>
      <Loader color="sage" size="xl" />
      <Text size="lg" ta="center" style={{ color: 'var(--aviary-ink)', minHeight: 28 }}>
        {NARRATION[lineIndex]}
      </Text>
    </Stack>
  );
}
